import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from './Loader';
import { WelcomeMessageButton } from 'models/digitalMap';
import { WelcomeMessage as WelcomeMessageType } from 'components/Chat/ChatContext';
import styles from './WelcomeMessage.module.css';
import clsx from 'clsx';

interface WelcomeMessageProps {
  onButtonClick?: (welcomeMessage: WelcomeMessageType, button: WelcomeMessageButton) => void;
  className?: string;
  isCollapsed?: boolean;
  message?: string;
  buttons?: WelcomeMessageButton[];
  selectedButton?: string;
  isLoading?: boolean;
}

export const WelcomeMessage: React.FC<WelcomeMessageProps> = ({
  onButtonClick,
  className,
  isCollapsed,
  message,
  buttons,
  selectedButton,
  isLoading,
}) => {
  const { t } = useTranslation();

  const welcomeMessage: WelcomeMessageType = {
    text: message ?? t("Hi, I'm your AI concierge. How can I help you today?"),
    buttons: buttons ?? [],
  };

  return (
    <div className={className}>
      <div className={clsx(styles.messageText, isCollapsed && styles.messageTextHidden)}>
        {isLoading ? <Loader /> : welcomeMessage.text}
      </div>
      {!isLoading && buttons && buttons.length > 0 && (
        <div className={clsx(styles.buttonsContainer, isCollapsed && styles.buttonsHidden)}>
          {selectedButton
            ? buttons
                .filter((button) => button.label === selectedButton)
                .map((button) => (
                  <div key={button.label}>
                    <button
                      key={button.label}
                      className={clsx(styles.button, styles.selectedButton)}
                    >
                      {button.icon_url && <img src={button.icon_url} alt="logo" />}
                      {button.label}
                    </button>
                    {button.prompt_text && (
                      <div className={styles.promptText}>{button.prompt_text}</div>
                    )}
                  </div>
                ))
            : buttons.map((button) => (
                <button
                  key={button.label}
                  className={styles.button}
                  onClick={() => onButtonClick?.(welcomeMessage, button)}
                >
                  {button.icon_url && <img src={button.icon_url} alt="logo" />}
                  {button.label}
                </button>
              ))}
        </div>
      )}
    </div>
  );
};
